import * as React from 'react';

import FileIndesign16 from './FileIndesign16';

export const fileIndesign16 = () => <FileIndesign16 />;

export default {
    title: 'Icon/Fill/FileIndesign16',
    component: FileIndesign16,
    parameters: {
        notes: "`import FileIndesign16 from 'box-ui-elements/es/icon/fill/FileIndesign16';`",
    },
};
